<template>
  <div>
    <user-table />
  </div>
</template>

<script>
  import UserTable from './pogs-users__table'

  import Permissions from '../../../mixins/permissions-mixin'
  import {ROOT_ADMIN_PERMISSIONS} from '../../../reference/pogs-functional-permissions'

  export default {
    mixins: [Permissions],
    components:{
      UserTable
    },
    mounted(){
      if(this.hasPermissionFor(ROOT_ADMIN_PERMISSIONS)){
        console.log('Has access to admin page')
      }else{
        console.log('You dont have access to admin page')
      }
    }
  }
</script>

<style scoped>

</style>
